export const openApp = () => {
  if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    const loadDateTime = new Date().getTime()
    window.location.href = 'yeeha://app_launch/deeplink' // schema链接或者 universal link
    window.setTimeout(function () {
      // 如果没有安装 APP,便会执行 setTimeout 跳转下载页
      const timeOutDateTime = new Date().getTime()
      if (timeOutDateTime - loadDateTime < 3000) {
        window.location.href = 'https://yeehagames.onelink.me/yn3E/6z6waexi' // IOS 下载地址
      } else {
        window.close()
      }
    }, 500)
  } else if (navigator.userAgent.match(/android/i)) {
    window.open('https://yeehagames.onelink.me/yn3E/6z6waexi')
    // window.location.href = 'https://yeehagames.onelink.me/yn3E/6z6waexi' // Android 下载地址
    //   try {
    //     window.location.href = 'yeeha://app_launch/deeplink' // schema 链接或者 universal link
    //     window.setTimeout(function () {
    //       window.location.href = 'https://yeehagames.onelink.me/yn3E/6z6waexi' // Android 下载地址
    //     }, 500)
    //   } catch (e) {}
    // }
  }
}
